import { initWechatShare } from "@/utils/wechat";
import i18n from "@/utils/i18n";

export function getBgImg(eventInfo) {
  let url = "../../../assets/images/bg.jpg";

  if (eventInfo.bgImg && eventInfo.bgImg.startsWith("http")) {
    url = eventInfo.bgImg;
  } else {
    url = `https://c.icode.org.cn/statics/assets/backgrounds/std_bg_${eventInfo.bgImg}.jpg`
  }

  return { background: `url("${url}") center / cover no-repeat` }
}

export const knowledgeData = [
  [{
    knowledge: "基本操作",
    level_1: "基本运动指令",
    level_2: "基本运动指令",
  }, {
    knowledge: "重复执行",
    level_1: "简单重复执行\n简单路线规划",
    level_2: "复杂重复规划",
    level_3: "重复执行应用\n简单嵌套重复",
    level_4: "简单嵌套重复\n复杂嵌套重复",
    level_5: "嵌套重复\n嵌套综合应用",
  }, {
    knowledge: "变量",
    level_1: "变量基础\n重复与变量",
    level_2: "重复与变量\n多变量的应用\n变量的计算",
    level_3: "重复与变量\n变量的计算",
    level_4: "重复与变量\n变量的计算",
    level_5: "重复与变量\n变量的计算",
  }, {
    knowledge: "条件语句",
    level_3: "如果积木入门\n双分支条件入门\n逻辑运算积木",
    level_4: "复杂条件应用\n逻辑运算积木",
    level_5: "条件语句综合应用",
  }, {
    knowledge: "函数",
    level_5: "简单函数\n带参数的函数",
  }],
  [{
    knowledge: "基本操作",
    level_1: "基本运动指令",
    level_2: "基本运动指令",
  }, {
    knowledge: "for循环",
    level_1: "for循环基础\n简单循环规划",
    level_2: "复杂循环规划\n循环中的变量\nrange函数",
    level_3: "复杂循环规划\n循环中的变量",
    level_4: "循环中的变量\n简单嵌套循环\n复杂嵌套循环",
    level_5: "循环中的变量\n简单嵌套循环\n复杂嵌套循环",
  }, {
    knowledge: "变量",
    level_1: "变量基础\n循环与变量\n多变量的应用",
    level_2: "坐标的应用\n坐标的计算",
    level_3: "坐标的计算",
    level_4: "坐标的应用",
    level_5: "坐标的应用",
  }, {
    knowledge: "列表",
    level_2: "飞板的应用\n列表的遍历",
    level_3: "坐标与列表遍历的综合应用",
    level_4: "列表的遍历\n列表综合应用",
    level_5: "列表的遍历\n列表综合应用",
  }, {
    knowledge: "条件语句",
    level_3: "if语句入门\n双分支条件\n逻辑运算符",
    level_4: "if语句综合应用",
    level_5: "if语句综合应用",
  }, {
    knowledge: "while语句",
    level_4: "while入门\n太阳能板/绿色飞板/绿色能量",
    level_5: "while应用\nwhile语句综合应用",
  }, {
    knowledge: "函数",
    level_5: "简单函数\n带参数的函数",
  }],
  [{
    knowledge: "基本操作",
    level_1: "基本运动指令",
    level_2: "基本运动指令",
  }, {
    knowledge: "for循环",
    level_1: "for循环基础\n简单循环规划",
    level_2: "复杂循环规划\n循环中的变量\nrange函数",
    level_3: "复杂循环规划\n循环中的变量",
    level_4: "循环中的变量\n简单嵌套循环\n复杂嵌套循环",
    level_5: "循环中的变量\n简单嵌套循环\n复杂嵌套循环",
  }, {
    knowledge: "变量",
    level_1: "变量基础\n循环与变量\n多变量的应用",
    level_2: "坐标的应用\n坐标的计算",
    level_3: "坐标的计算",
    level_4: "坐标的应用",
    level_5: "坐标的应用",
  }, {
    knowledge: "列表",
    level_2: "飞板的应用\n列表的遍历",
    level_3: "坐标与列表遍历的综合应用",
    level_4: "列表的遍历\n列表综合应用",
    level_5: "列表的遍历\n列表综合应用",
  }, {
    knowledge: "条件语句",
    level_3: "if语句入门\n双分支条件\n逻辑运算符",
    level_4: "if语句综合应用",
    level_5: "if语句综合应用",
  }, {
    knowledge: "while语句",
    level_4: "while入门\n太阳能板/绿色飞板/绿色能量\nwhile语句综合应用",
    level_5: "while应用\nwhile语句综合应用",
  }, {
    knowledge: "函数",
    level_5: "简单函数\n带参数的函数\n递归函数",
  }],
];

function updateMainLinks(eventInfo) {
  if (!eventInfo.mainLinks) return;
  try {
    eventInfo.mainLinks = JSON.parse(eventInfo.mainLinks)
  } catch (e) {
    eventInfo.mainLinks = [];
  }
}

function updateOrgList(eventInfo) {
  try {
    eventInfo.orgList = JSON.parse(eventInfo.supportOrganization);
    eventInfo.orgList.forEach((item, index) => {
      Object.keys(item).forEach((k, i) => {
        if (typeof item[k] == 'string') {
          item[k] = [item[k]];
        }
      })
    });
  } catch (e) {
    eventInfo.orgList = [];
  }
}

function updateToprightLinks(eventInfo) {
  if (!eventInfo.toprightLinks) return;
  try {
    eventInfo.toprightLinks = JSON.parse(eventInfo.toprightLinks)
  } catch (e) {
    eventInfo.toprightLinks = [];
  }
}

function updateConfig(eventInfo) {
  try {
    eventInfo.config = JSON.parse(eventInfo.config);
  } catch (e) {
    eventInfo.config = {};
  }
}

export function parseEventInfo(eventInfo) {
  updateOrgList(eventInfo);
  updateMainLinks(eventInfo);
  updateToprightLinks(eventInfo);
  updateConfig(eventInfo);

  document.title = i18n.t(eventInfo.eventTitle);
  initWechatShare(
    i18n.t(eventInfo.eventTitle),
    i18n.t(eventInfo.event_explain)
  );
}


// WEBPACK FOOTER //
// ./src/components/contest/template/event.js